import React from 'react';
import Dialog from '@material-ui/core/Dialog';

import DialogBody from './DialogBody';

export default function ServiceRequestDialog({ open, setOpen }) {
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <Dialog id="service_request_dialog" open={open} onClose={handleClose} style={{ height: '100%' }}>
        <DialogBody setOpen={setOpen} handleBackOnClick={handleClose} />
      </Dialog>
    </>
  );
}
